import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRecruiter } from "../context/RecruiterContext.tsx";
import ProfileSetupWizard from "./ProfileSetupWizard.tsx";
import Resume from "./resume/resume.tsx";
interface Experience {
    role: string;
    company: string;
    startDate: string;
    endDate: string;
    present: boolean;
    description: string;
}

interface Education {
    institution: string;
    degree: string;
    fieldOfStudy: string;
    duration: string;
}

interface Certification {
    name: string;
    issuingOrganization: string;
    date: string;
}

interface Profile {
    ID: string;
    UserID: string;
    Name: string;
    Email: string;
    Phone: string;
    Linkedin: string;
    Github: string;
    Website: string;
    Summary: string;
    Experience: string;
    Education: string;
    Skills: string;
    Certifications: string;
    CreatedAt: string;
    ProfilePicture: string | null;
}

interface ProfileResponse {
    Profile: Profile;
    ProfileFound: string;
}

interface UserDetails {
    ID: string;
    Userid: string;
    Company: string | null;
    Position: string | null;
    CreatedAt: string;
    Phone: string | null;
    Email: string;
    Linkedin: string | null;
    Github: string | null;
}
const CandidateDashboard: React.FC = () => {
    const isRecruiter = useRecruiter();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);
    const [candidateProfile, setCandidateProfile] = useState<ProfileResponse | null>(null);
    const [userDetails, setUserDetails] = useState<UserDetails | null>(null);

    useEffect(() => {
        if (!isRecruiter.isLoggedIn) {
            navigate('/login');
            return;
        }

        const fetchData = async () => {
            try {
                console.log('Fetching profile and user details...');

                const profileResponse = await fetch('/candidate/profile');


                const userDetailsResponse = await fetch('/api/getuserdetails');


                if (!profileResponse.ok) {
                    throw new Error(`Profile fetch failed: ${profileResponse.status}`);
                }
                if (!userDetailsResponse.ok) {
                    throw new Error(`User details fetch failed: ${userDetailsResponse.status}`);
                }

                const [profileData, userData] = await Promise.all([
                    profileResponse.json(),
                    userDetailsResponse.json()
                ]);

                setCandidateProfile(profileData);
                setUserDetails(userData);
            } catch (err) {
                setError('Failed to load data');
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [isRecruiter.isLoggedIn, navigate]);

    if (loading) return <div>Loading...</div>;
    if (error) return <div>Error: {error}</div>;
    if (!candidateProfile?.Profile) {
        console.log('No profile found, showing wizard');
        return <ProfileSetupWizard userData={userDetails || null} />;
    }

    console.log('Rendering Resume with profile:', candidateProfile.Profile);
    return <Resume profile={candidateProfile.Profile} />;
};

export default CandidateDashboard;